module.exports = __webpack_public_path__ + "static/media/document-week12.bc940e92.pdf";